import { LOGO_URL, NAV_ITEMS, CONTACT } from "../lib/constants";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-slate-950 text-white"
      style={{ backgroundColor: "hsl(var(--pv-deep-green))" }}
    >
      <div className="mx-auto max-w-7xl px-5 lg:px-8 py-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-3">
            <div className="bg-white p-2 rounded-sm">
              <img
                src={LOGO_URL}
                alt="Pino Verde"
                className="h-12 w-12 object-contain"
              />
            </div>
            <div>
              <div className="font-display font-extrabold text-xl tracking-tight">
                PINO VERDE
              </div>
              <div className="overline text-pv-orange">Salud Ocupacional</div>
            </div>
          </div>
          <p className="mt-5 text-sm text-white/70 max-w-md leading-relaxed">
            Especialistas en salud ocupacional. Cuidamos a las personas que
            mueven Costa Rica con equipo de protección certificado y
            asesoramiento experto.
          </p>
        </div>

        <div>
          <div className="overline text-pv-lime mb-4">Navegación</div>
          <ul className="space-y-2.5">
            {NAV_ITEMS.map((n) => (
              <li key={n.href}>
                <a
                  href={n.href}
                  data-testid={`footer-nav-${n.href.replace("#", "")}`}
                  className="text-sm text-white/75 hover:text-pv-orange transition-colors"
                >
                  {n.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="overline text-pv-lime mb-4">Contacto</div>
          <ul className="space-y-2.5 text-sm text-white/75">
            <li>
              <a
                href={`mailto:${CONTACT.email}`}
                className="hover:text-pv-orange transition-colors"
              >
                {CONTACT.email}
              </a>
            </li>
            <li>Tel: (506) {CONTACT.phone}</li>
            <li>WhatsApp: (506) {CONTACT.whatsapp}</li>
            <li className="pt-2 text-white/60">{CONTACT.address}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-5 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-white/50">
          <div>
            © {new Date().getFullYear()} Pino Verde Salud Ocupacional. Todos
            los derechos reservados.
          </div>
          <div>Hecho en Costa Rica · Protegiendo desde 2003</div>
        </div>
        <div className="mx-auto max-w-7xl px-5 lg:px-8 pb-5 text-[11px] text-white/40 leading-relaxed">
          Todas las marcas, logotipos y nombres comerciales mostrados en este
          sitio pertenecen a sus respectivos titulares y se utilizan
          únicamente con fines identificativos de los productos que
          distribuimos. Su presencia no implica patrocinio ni afiliación
          exclusiva con Pino Verde Salud Ocupacional.
        </div>
      </div>
    </footer>
  );
}
